import React from 'react';
import { useTranslation } from 'react-i18next';
import { buildSeoTitle } from 'shared/lib/seoHelpers';
import Page from 'userportal/components/Page';
import Subheader from 'shared/components/Subheader';
import LegalDocument from 'shared/components/LegalDocument';
import styles from './Gdpr.module.scss';

const GdprPage = () => {
  const { t } = useTranslation(['userportal', 'common']);
  const doc = t('page.gdpr', { returnObjects: true });

  return (
    <Page
      initialRow={false}
      subheader={(
        <Subheader center title={doc.title}>
          <span>{doc.meta}</span>
        </Subheader>
      )}
      helmetTitle={buildSeoTitle(t, doc.title)}
    >
      <LegalDocument doc={doc} className={styles.gdpr} />
    </Page>
  );
};

export default GdprPage;
